// -------------------------------------------------------------------------------------------
// The goal of this file is to allow asynchronous importing of DevExpress components.
// If you import all classes directly in your components, DevExpress will be included in your bundle.
// But DevExpress components are huge (~600KB gzipped), so we want to load them asynchronously.
// -------------------------------------------------------------------------------------------
// HOW TO USE:
// 1. import DevExpress components ONLY from this file (never from 'devextreme' directly)
// 2. For components use `<DXG.component_name />` (e.g. `<DXG.Button />`), for instantiation use use `new DXG.class_name()`

import type {
  ToolbarPreparingInfo,
  EditingStartEvent,
} from 'devextreme/ui/data_grid';

import type dxDataGrid from 'devextreme/ui/data_grid';
import type { EventInfo } from 'devextreme/events';
import type { Autocomplete } from 'devextreme-react/autocomplete';
import type { DataGrid, CheckBox } from 'devextreme-react';
import type { IEditingProps } from 'devextreme-react/data-grid';
import type {
  Column,
  Paging,
  Pager,
  Editing,
  Lookup,
  Button,
  RequiredRule,
  SearchPanel,
  Sorting,
  Export,
  AsyncRule,
  CustomRule,
} from 'devextreme-react/data-grid';
//import type { DataGridRef } from 'devextreme-react/cjs/data-grid';
import 'devextreme/dist/css/dx.light.css';
import { useDataSource } from '../dx-data-source';
export type {
  DataGrid,
  // DataGridRef,
  CheckBox,
  ToolbarPreparingInfo,
  EventInfo,
  dxDataGrid,
  EditingStartEvent,
  IEditingProps,
  Export,
};
export const DXG: {
  Button: typeof Button;
  RequiredRule: typeof RequiredRule;
  SearchPanel: typeof SearchPanel;
  Sorting: typeof Sorting;
  Export: typeof Export;
  Column: typeof Column;
  Paging: typeof Paging;
  Pager: typeof Pager;
  Editing: typeof Editing;
  Lookup: typeof Lookup;
  AsyncRule: typeof AsyncRule;
  CustomRule: typeof CustomRule;
  Autocomplete: typeof Autocomplete;

  CheckBox: typeof CheckBox;
  DataGrid: typeof DataGrid;
} = {} as any;
let _promise: Promise<any> | null;
let _isLoaded: boolean;
let _error: any;

export function useDataGrid() {
  useDataSource();
  if (!_isLoaded) {
    if (!_promise) {
      _promise = initDataGrid();
    }
    // will trigger Suspense
    throw _promise;
  }
  if (_error) {
    throw _error;
  }
}

function initDataGrid() {
  return Promise.all([
    import('devextreme-react')
      .then((x) => {
        DXG.DataGrid = x.DataGrid;
        DXG.CheckBox = x.CheckBox;
      })
      .catch((e) => console.error(e)),
    import('devextreme-react/data-grid').then((x) => {
      DXG.Button = x.Button;
      DXG.RequiredRule = x.RequiredRule;
      DXG.SearchPanel = x.SearchPanel;
      DXG.Sorting = x.Sorting;
      DXG.Column = x.Column;
      DXG.Paging = x.Paging;
      DXG.Editing = x.Editing;
      DXG.Lookup = x.Lookup;
      DXG.AsyncRule = x.AsyncRule;
      DXG.CustomRule = x.CustomRule;
      DXG.Export = x.Export;
    }),
    import('devextreme-react/autocomplete').then((x) => {
      DXG.Autocomplete = x.Autocomplete;
    }),
  ])
    .finally(() => (_isLoaded = true))
    .catch((e) => (_error = e));
}
